import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faChevronRight, faKeyboard, faCalculator } from '@fortawesome/free-solid-svg-icons';

const Projects = ({ setState }) => (
	<div className="projects">
		<div class="exitbtn" onClick={() => setState('home')}>
			<FontAwesomeIcon icon={faArrowLeft} className="exitbtn__icon" />
		</div>
		<a href="http://94.181.190.26/10v/skripko/keytyper" className="projects__entry">
			<FontAwesomeIcon icon={faKeyboard} className="projects__entry__icon" />
			Keytyper
			<div className="entranceind">
				<FontAwesomeIcon icon={faChevronRight} className="entranceind__icon" />
			</div>
		</a>
		<a href="https://katsuki.codeberg.page/fluentcalc/dist/" className="projects__entry">
			<FontAwesomeIcon icon={faCalculator} className="projects__entry__icon" />
			fluentcalc
			<div className="entranceind">
				<FontAwesomeIcon icon={faChevronRight} className="entranceind__icon" />
			</div>
		</a>
	</div>
)

export default Projects;
